<template>
  <div class="home">
    <img :src="comData.connectPicBackground || homeBackground" alt="" mode="widthFix" />
    <div class="time-box">
      <div class="title">时间</div>
      <div class="time">{{comData.timeLimit}}s</div>
    </div>
    <div class="box">
      <template v-if="isPreivew == 'false'">
        <img 
          v-for="(item,index) in imgList"
          :src="item.base64Img"
          :key="index" 
          :style="{width: 300 / comData.challengeLevel + 'px',height: 300 / comData.challengeLevel + 'px'}"
        />
      </template>
      <template v-else>
        <img 
          :src="comData.connectPic"
          :style="{width: '300px',height: '300px'}"
        />
      </template>
    </div>
    <div class="button-box">
      <img src="https://img3.quanyou.com.cn/joy/group1/M00/17/50/rB4ChWM2X9aALv-tAACO9fM-e9Y307.png" alt=""  @click="show =true">
    </div>
    <van-popup v-model="show">
      <div class="popup">
        <img class="popup-img" :src="comData.connectPic" alt="">
        <img class="popup-button" src="https://img3.quanyou.com.cn/joy/group1/M00/17/50/rB4ChWM2YGqAa05JAACIkrstIXM592.png"  @click="show =false" alt="">
      </div>
    </van-popup>
  </div>
</template>

<script>
export default {
  computed: {
    comData() {
      return this.$route.query
    },
    isPreivew() {
      return this.$route.query.isPreivew
    }
  },
  data() {
    return {
      homeBackground: 'https://img3.quanyou.com.cn/joy/group1/M00/17/51/rB4ChWM2eK2AOGAFAArmhM2si8c128.png',
      show: false,
      imgList: [],
    }
  },
  methods: {
    getConnectPicBase64Img() {
      this.$api.connectPic.getConnectPicBase64Img(this.comData.activityId).then(res => {
        if (res.success) {
          this.imgList = this.randomSort(res.data) 
        }
      })
    },
    randomSort(arr) {
      let result = []
      while (arr.length) {
        let index = Math.floor(Math.random() * arr.length)
        result.push(arr[index])
        arr.splice(index, 1)
      }
      return result
    },
  },
  mounted() {
    // 不是预览
    if (this.isPreivew == 'false') {
      this.getConnectPicBase64Img()
    }
  },
 
}
</script>

<style lang="stylus" scoped>
  .home {
    position: relative
    height 100%
    overflow hidden
    font-size 0
    img {
      width 100%
      height auto
    }
    .time-box {
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      position: absolute;
      top: 90px;
      color: #FFF6C0;
      font-weight: bold;
      .title {
        font-size: 23px;
      }
      .time {
        font-size: 26px;
        margin-top: 11px;
      }

    }
    .box {
      position:absolute;
      width: 300px;
      height: 300px;
      background: #FEF9CF;
      bottom: 184px;
      left:50%;
      margin-left: -150px;
    }
    .button-box {
        position:absolute;
        bottom: 62px;
        left:50%;
        transform: translateX(-50%);
      img {
        width: 185px;
        height: 75px;
        margin-bottom: 10px;
      }
    }
    .van-popup {
      background: rgba(0,0,0,0);
    }
    .popup {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .popup-img {
        width: 300px;
        height: 300px;
        background: #FEF9CF;
      }
      .popup-button {
        width: 185px;
        height: 75px;
        margin-top: 59px
      }
    }
    
  }
 
</style>